import { useRef, useState } from "react";
import { EnviaDatosAServicio } from "../../Funciones/Funciones";
import useToken from "../login/useToken";
import classes from "./LlaveNueva.module.css";
import { Slide, toast } from "react-toastify";
import { PatternFormat } from "react-number-format";

function NuevaLlave(props) {
  //const llaveRef = useRef();
  const estatusRef = useRef();
  const observRef = useRef();
  const token = useToken().token;
  const idCasa = token.casaSel;
  const [LlaveInput, setllaveInput] = useState("");

  function CancelaNuevo(ev) {
    ev.preventDefault();
    props.setMostrarNuevo(false);
  }

  const submitHandler = async (ev) => {
    ev.preventDefault();
    const DatosValidos = ValidaDatos();
    if (DatosValidos === "") {
      const llaveN = {
        Llave: LlaveInput.toString().trim(),
        Estatus: estatusRef.current.value,
        Observaciones: observRef.current.value,
        IDCasa: idCasa,
      };
      console.log("llaveN", llaveN);
      const envio = await EnviaDatosAServicio(llaveN, "AltaLlave");
      if (envio.ERROR === "") {
        toast("Guardado OK", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          transition: Slide,
        });
        props.llaveCompleta();
      } else {
        props.setTextoModal("Error al guardar:\n" + envio.DESCERROR);
        props.setMostrandoError(true);
        props.setMuestraDialogoOK(true);
        //alert("Error al guardar: " + envio.DESCERROR);
      }
    } else {
      props.setTextoModal("Revisa los siguientes datos\n" + DatosValidos);
      props.setMostrandoError(true);
      props.setMuestraDialogoOK(true);
      //alert("Revisa los siguientes datos\n" + DatosValidos);
    }
  };

  function ValidaDatos() {
    var respuesta = "";

    if (LlaveInput === "" || parseInt(LlaveInput) === 0) {
      respuesta = respuesta + "Numero de la llave\n";
    }
    if (estatusRef.current.value === "0") {
      respuesta = respuesta + "estatus de habitación\n";
    }
    return respuesta; // respuesta;
  }

  /********************************************************************************/
  /*************************** RENDER *********************************************/
  /********************************************************************************/

  return (
    <section className={classes.modal}>
      <div className={classes.contBotTop}>
        {props.nivel === 1 && (
          <button className={classes.botTop} onClick={submitHandler}>
            <i className="fas fa-save"></i>
          </button>
        )}
        <button onClick={CancelaNuevo}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <h1 className={classes.h1loc}>Nueva Llave</h1>
      <form onSubmit={submitHandler}>
        <div>
          <div>
            <label className={classes.labelP}>Llave:</label>
            <PatternFormat
              maxLength="12"
              format="##########"
              valueIsNumericString={true}
              id="Llave"
              type="text"
              className={classes.textareaNE}
              placeholder="Número llave"
              onValueChange={(values) => {
                setllaveInput(values.formattedValue);
              }}
            ></PatternFormat>
            {/*<input
              type="text"
              maxLength="12"
              ref={llaveRef}
              placeholder="Número llave"
              className={classes.textareaNE}
              onPaste={validaNumeros}
              onKeyPress={validaNumeros}
            ></input>*/}
          </div>
          <div>
            <label className={classes.labelP}>Estatus:</label>
            <select ref={estatusRef} className={classes.textareaNE}>
              <option key="0" value={"0"}>
                Selecciona el estatus
              </option>
              <option key="1" value={"OK"}>
                OK
              </option>
              <option key="2" value={"PERDIDA"}>
                Perdida
              </option>
              <option key="3" value={"NOSIRVE"}>
                No Sirve
              </option>
            </select>
          </div>
          <div>
            <label className={classes.labelP}>Observaciones:</label>
            <input
              type="text"
              ref={observRef}
              placeholder="algún comentario?"
              className={classes.textareaNE}
            ></input>
          </div>
        </div>
      </form>
    </section>
  );
}

export default NuevaLlave;
